import { colors } from '../foundation';

type Props = {
  color?: typeof colors.primary.red | typeof colors.primary.white;
};

const Ellipse = ({ color = colors.primary.red }: Props) => {
  return (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse id="Ellipse 137" cx="4" cy="4" rx="4" ry="4" fill={color} />
    </svg>
  );
};

export default Ellipse;
